"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCompositeContext = void 0;
const react_1 = require("react");
const component_1 = require("../component");
/**
 * Возвращает конфигурацию всех ui компонентов
 */
const useCompositeContext = () => (0, react_1.useContext)(component_1.CompositeContext);
exports.useCompositeContext = useCompositeContext;
